<ucdhs-ais-idle-session
  [debugLevel]="debugLevels.NONE"
  [debugCallback]="debugCallback"
  [keepAlives]="keepalives"
  [continueCallback]="continueSession.bind(this)"
></ucdhs-ais-idle-session>

<ng-container *ngIf="securityChecked">
  <p-confirmDialog
    key="confirmDialogLeftJustified"
    styleClass="ais-confirm-dialog"
    header="Confirmation"
    appendTo="body"
  ></p-confirmDialog>
  <p-confirmDialog
    key="confirmDialogDeleted"
    styleClass="ais-confirm-dialog"
    header="Confirmation"
    appendTo="body"
  ></p-confirmDialog>
  <p-confirmDialog
    key="confirmDialogCenterJustified"
    styleClass="ais-confirm-dialog ais-confirm-dialog-centered"
    header="Confirmation"
    appendTo="body"
  ></p-confirmDialog>
</ng-container>

<!-- LANDMARK: Cleanly separate top app-header layout tracking strings -->
<header role="banner" *ngIf="securityChecked && !isIE">
  <app-app-header
    [allowed]="allowed"
    [securityChecked]="securityChecked"
  ></app-app-header>
</header>

<!-- SUB-CONTAINER: Content elements nest uniformly within this space -->
<div class="app-content-body">
  <ng-container *ngIf="!securityChecked && !isIE">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-container *ngIf="securityChecked">
    <div
      *ngIf="isSafari"
      class="container"
      style="padding-top: 50px; text-align: center"
    >
      <h3 style="margin-top: 20px">
        This application is not supported by Safari. Please use Edge, Chrome or
        Firefox.
      </h3>
    </div>
    <div
      *ngIf="isIE"
      class="container"
      style="padding-top: 50px; text-align: center"
    >
      <h3 style="margin-top: 20px">
        The HS Form Application is not supported by Internet Explorer. Please
        use Edge, Chrome or Firefox.
      </h3>
    </div>

    <ng-container *ngIf="allowed && !isIE">
      <router-outlet></router-outlet>
    </ng-container>

    <div
      *ngIf="!allowed && !isIE"
      class="container"
      style="padding-top: 50px; text-align: center"
    >
      <h1>Your login credential was rejected ...</h1>
      <h3 style="margin-top: 20px">
        You may not have permission to access the requested resource!
      </h3>
    </div>
  </ng-container>
</div>

<!-- LANDMARK: Isolate bottom app-footer text elements cleanly -->
<footer role="contentinfo" *ngIf="securityChecked && !isIE">
  <app-app-footer></app-app-footer>
</footer>
